@if (items.length > 0) {
  <div class="bg-white rounded-3xl shadow-sm p-4">
    <h3 class="text-base font-semibold text-vw-ink mb-1">
      {{ 'home.gdd.title' | translate }}
    </h3>

    <div class="divide-y divide-grey-100">
      @for (item of visibleItems; track item.plantUid) {
        <div class="flex items-center gap-3 py-3 cursor-pointer active:bg-grey-100/60 px-1 -mx-1 transition-colors"
          (click)="onPlantClick(item)">
          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-between gap-2 mb-0.5">
              <p class="text-sm font-medium text-vw-ink truncate">{{ item.cultivationName }}</p>
              @if (item.conditionBadge) {
                <vw-gdd-badge class="shrink-0" [conditionBadge]="item.conditionBadge"></vw-gdd-badge>
              }
            </div>

            @if (item.locationName) {
              <div class="flex items-center gap-1 mb-1.5 text-caption text-vw-muted">
                <vw-icon-svg iconUrl="/assets/svg/map-pinned.svg" width="12px" height="12px"></vw-icon-svg>
                <span class="truncate">{{ item.locationName | locationLabel }}</span>
              </div>
            }

            @if (item.waitingForSeason) {
              <!-- Plante cyclique : l'étape est finie, la suivante attend sa saison.
                   Pas de barre à 100 % qui ferait croire à une étape à surveiller. -->
              <p class="text-caption text-vw-muted" data-test="gdd-waiting">
                {{ 'garden.plant-details.waiting-season' | translate: { step: item.nextStepName, date: (item.nextStepOpensOn | vwDate: 'short') } }}
              </p>
            } @else {
              <vw-progress-bar [singleColor]="true" [progress]="progressPercent(item.progress)"></vw-progress-bar>

              <!-- « 60 % » puis l'étape, chacun dans son span : plus de tiret
                   long entre les deux. La date estimée s'écrit en mots. -->
              <div class="flex items-center gap-2 mt-1 text-caption text-vw-muted">
                <span class="shrink-0 font-medium text-vw-body" data-test="gdd-percent">{{ progressPercent(item.progress) | vwPercent }}</span>
                <span class="min-w-0 flex-1 truncate">{{ item.currentStepName }}</span>
                @if (item.endDate) {
                  <span class="shrink-0" data-test="gdd-around">{{ 'home.gdd.around' | translate: { date: (item.endDate | vwDate: 'short') } }}</span>
                }
              </div>
              @if (item.weatherGapDays) {
                <p class="mt-1 text-caption text-vw-muted" data-test="gdd-missing-weather">
                  {{ 'gdd.missing-weather' | vwPlural: item.weatherGapDays : { days: item.weatherGapDays } }}
                </p>
              }
            }
          </div>

          <vw-chevron-right-icon class="size-5 shrink-0 text-vw-icon-idle" aria-hidden="true" />
        </div>
      }
    </div>
  </div>
}
